import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "multicolumn-view" }
const _hoisted_2 = { class: "view-full-span" }
const _hoisted_3 = {
  key: 0,
  class: "view-full-span busy-indicator-container"
}
const _hoisted_4 = {
  key: 1,
  class: "error"
}

import { isAxiosError } from 'axios'
import isNil from 'lodash/isNil'
import { computed, onMounted, ref } from 'vue'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import BowlerProfileSummary from '@/components/widgets/bowler-app/BowlerProfileSummary.vue'
import BowlerResultsSummary from '@/components/widgets/bowler-app/BowlerResultsSummary.vue'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { useUserStore } from '@/store/bowler-app/user'
import { formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const bowler = useBowlerStore()
const user = useUserStore()

/* local state */

const error = ref<string | null>()
const isLoading = ref<boolean>(false)

/* hooks */

onMounted(async (): Promise<void> => {
  isLoading.value = true

  try {
    await user.fetch()
    if (!isNil(user.bowlerId)) {
      await bowler.fetch(String(user.bowlerId))
    }
  } catch (e) {
    const message = isAxiosError(e)
      ? (e.response?.data?.detail as string)
      : (e as string)
    console.error(`Failed fetching bowler's data: ${message}`)
    error.value = message
  }

  isLoading.value = false
})

/* computed */

const bowlerName = computed<string>((): string =>
  formatValue(bowler.firstName ?? user.firstName),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('general.greeting', { name: bowlerName.value })), 1),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
          _createVNode(BusyIndicator)
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('general.error-exclamation')) + " ", 1),
              _createElementVNode("strong", null, _toDisplayString(error.value), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(BowlerProfileSummary),
            _createVNode(BowlerResultsSummary)
          ], 64))
  ]))
}
}

})